import React from 'react';
import './TermsConditions.css';
import PageHero from './PageHero';
import { MIN_BOOKING_NIGHTS } from '../constants/booking';

const TermsConditions: React.FC = () => {
  return (
    <div className="terms-page">
      <PageHero
        title="Terms & Conditions"
        subtitle="Booking, deposits and our weather policy"
      />
      <div className="terms-container">
        <div className="terms-content">
          <p className="terms-intro">
            These terms apply to all stays at Southern Comfort Camps on the Houtman
            Abrolhos Islands. Please read them before enquiring so you know how bookings,
            payments and weather are handled. If anything is unclear, just ask us — we're
            happy to talk it through.
          </p>

          <section className="terms-section">
            <h2>Bookings &amp; enquiries</h2>
            <p>
              All stays are by enquiry and are confirmed by us, the caretakers. Submitting
              an enquiry does not guarantee a booking. A booking is only confirmed once we
              have agreed your dates in writing and received your deposit. As we live on the
              island to assist with your stay, bookings are also subject to host availability.
            </p>
          </section>

          <section className="terms-section">
            <h2>Deposit &amp; payment</h2>
            <ul>
              <li>A deposit of 30% of the total stay confirms your booking and secures your dates.</li>
              <li>The remaining balance is due 7 days before your arrival.</li>
              <li>
                All prices are in Australian dollars. Payment details will be provided when
                we confirm your dates.
              </li>
            </ul>
          </section>

          <section className="terms-section">
            <h2>Weather &amp; the crossing</h2>
            <p>
              We are located approximately 35 nautical miles offshore, and all guests travel
              in their own vessel. Because every boat and crew is different, whether the
              crossing can safely go ahead is decided by Southern Comfort Camps in discussion
              with you, using the latest forecast together with your knowledge of your own
              vessel. There is no fixed wind or swell figure — each crossing is assessed on its
              own merits.
            </p>
            <p>
              Where there is a genuine concern that the crossing cannot be made safely, we
              will refund everything you have paid in full, including your deposit, or move
              your booking to another mutually suitable date — whichever you prefer. We simply
              ask that you let us know as early as you reasonably can once the forecast is clear.
            </p>
          </section>

          <section className="terms-section">
            <h2>Cancellations by you</h2>
            <p>Where a cancellation is for reasons other than unsafe weather:</p>
            <ul>
              <li>The 30% deposit is non-refundable.</li>
              <li>
                If you cancel 7 or more days before your arrival, any balance paid is refunded
                in full and you forfeit only the deposit.
              </li>
              <li>
                If you cancel within 7 days of your arrival, the deposit and balance are
                non-refundable. We will do our best to re-let the dates and, where we can,
                refund you as a goodwill gesture.
              </li>
            </ul>
            <p className="terms-note">
              The weather policy above always takes precedence: where the crossing cannot be
              made safely, you receive a full refund including your deposit.
            </p>
          </section>

          <section className="terms-section">
            <h2>Getting here &amp; your responsibilities</h2>
            <ul>
              <li>
                Guests must arrange their own vessel transport to and from the island and be
                self-sufficient in remote maritime travel.
              </li>
              <li>
                You are responsible for your own vessel, navigation, safety and the decision to
                travel in the conditions on the day.
              </li>
              <li>
                There are no shops or services on the island. Stays are fully self-catered, so
                please arrive with all the provisions you will need.
              </li>
              <li>Bookings are for a minimum of {MIN_BOOKING_NIGHTS} nights.</li>
            </ul>
          </section>

          <section className="terms-section">
            <h2>On the island</h2>
            <p>
              We are on-island caretakers here to help make your stay comfortable, but this is
              not a serviced hotel. All stays are subject to sea and weather conditions
              throughout. Please treat the camps, the island and its wildlife with care so
              they remain healthy for the long term.
            </p>
          </section>

          <section className="terms-section">
            <h2>Safety, liability &amp; insurance</h2>
            <p>
              The Abrolhos is a remote environment and travel to and from the island carries
              inherent risks that rest with you as skipper of your own vessel. To the extent
              permitted by law, Southern Comfort Camps is not liable for loss, injury or delay
              arising from vessel travel, weather or other circumstances outside our control.
              We strongly recommend arranging appropriate travel and boating insurance.
            </p>
          </section>

          <section className="terms-section">
            <h2>Contact</h2>
            <div className="terms-contact">
              <p><strong>Email:</strong> info@southerncomfortcamps.com</p>
              <p><strong>Phone:</strong> (+61) 0439 690 119</p>
              <p><strong>Location:</strong> Abrolhos Islands, Western Australia</p>
            </div>
            <p className="terms-updated">Last updated: July 2026</p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default TermsConditions;
